import { render, staticRenderFns } from "./passReject.vue?vue&type=template&id=cfd828d6&scoped=true"
import script from "./passReject.vue?vue&type=script&lang=js"
export * from "./passReject.vue?vue&type=script&lang=js"
import style0 from "./passReject.vue?vue&type=style&index=0&id=cfd828d6&prod&scoped=true&lang=css"
import style1 from "./passReject.vue?vue&type=style&index=1&id=cfd828d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfd828d6",
  null
  
)

export default component.exports